/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SystemBoundaryEntity,
} from '../models/index';
import {
    SystemBoundaryEntityFromJSON,
    SystemBoundaryEntityToJSON,
} from '../models/index';

export interface CreateBoundaryRequest {
    systemBoundaryEntity: SystemBoundaryEntity;
    sessionId?: string;
}

export interface DeleteBoundaryRequest {
    boundaryId: string;
    sessionId?: string;
}

export interface GetAssignmentHistoryRequest {
    boundaryId: string;
    page?: number;
    pageSize?: number;
    changeType?: string;
    startTime?: string;
    endTime?: string;
    sessionId?: string;
}

export interface GetAssignmentHistoryStatsRequest {
    boundaryId: string;
    sessionId?: string;
}

export interface GetBoundariesRequest {
    page?: number;
    pageSize?: number;
    boundaryType?: string;
    authorizationStatus?: string;
    tenantIds?: string;
    sessionId?: string;
}

export interface GetBoundaryRequest {
    boundaryId: string;
    tenantIds?: string;
    sessionId?: string;
}

export interface GetBoundaryAssetsRequest {
    boundaryId: string;
    page?: number;
    pageSize?: number;
    sessionId?: string;
}

export interface GetBoundaryComplianceRequest {
    boundaryId: string;
    sessionId?: string;
}

export interface GetBoundaryStatisticsRequest {
    sessionId?: string;
}

export interface GetBoundaryVulnerabilitiesRequest {
    boundaryId: string;
    sessionId?: string;
}

export interface GetComplianceByAssetRequest {
    boundaryId: string;
    sessionId?: string;
}

export interface GetComplianceByBaselineRequest {
    boundaryId: string;
    sessionId?: string;
}

export interface GetEntityAssignmentHistoryRequest {
    entityType: string;
    entityId: string;
    page?: number;
    pageSize?: number;
    sessionId?: string;
}

export interface RecalculateComplianceRequest {
    boundaryId: string;
    includeParents?: boolean;
    sessionId?: string;
}

export interface UpdateBoundaryRequest {
    boundaryId: string;
    systemBoundaryEntity: SystemBoundaryEntity;
    sessionId?: string;
}

/**
 * SystemBoundariesApi - interface
 * 
 * @export
 * @interface SystemBoundariesApiInterface
 */
export interface SystemBoundariesApiInterface {
    /**
     * Create a new system boundary
     * @summary Create boundary
     * @param {SystemBoundaryEntity} systemBoundaryEntity 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemBoundariesApiInterface
     */
    createBoundaryRaw(requestParameters: CreateBoundaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Create a new system boundary
     * Create boundary
     */
    createBoundary(requestParameters: CreateBoundaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Delete a system boundary
     * @summary Delete boundary
     * @param {string} boundaryId Boundary ID
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemBoundariesApiInterface
     */
    deleteBoundaryRaw(requestParameters: DeleteBoundaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Delete a system boundary
     * Delete boundary
     */
    deleteBoundary(requestParameters: DeleteBoundaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get paginated assignment history for a boundary
     * @summary Get assignment history
     * @param {string} boundaryId Boundary ID
     * @param {number} [page] Page number (0-indexed)
     * @param {number} [pageSize] Page size
     * @param {string} [changeType] Change type filter
     * @param {string} [startTime] Start time (ISO 8601)
     * @param {string} [endTime] End time (ISO 8601)
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemBoundariesApiInterface
     */
    getAssignmentHistoryRaw(requestParameters: GetAssignmentHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get paginated assignment history for a boundary
     * Get assignment history
     */
    getAssignmentHistory(requestParameters: GetAssignmentHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get statistics about assignment history for a boundary
     * @summary Get assignment history statistics
     * @param {string} boundaryId Boundary ID
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemBoundariesApiInterface
     */
    getAssignmentHistoryStatsRaw(requestParameters: GetAssignmentHistoryStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get statistics about assignment history for a boundary
     * Get assignment history statistics
     */
    getAssignmentHistoryStats(requestParameters: GetAssignmentHistoryStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get paginated list of system boundaries for the tenant
     * @summary List system boundaries
     * @param {number} [page] Page number (0-indexed)
     * @param {number} [pageSize] Page size
     * @param {string} [boundaryType] Boundary type filter
     * @param {string} [authorizationStatus] Authorization status filter
     * @param {string} [tenantIds] Override tenant scope
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemBoundariesApiInterface
     */
    getBoundariesRaw(requestParameters: GetBoundariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get paginated list of system boundaries for the tenant
     * List system boundaries
     */
    getBoundaries(requestParameters: GetBoundariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get detailed information about a system boundary
     * @summary Get boundary by ID
     * @param {string} boundaryId Boundary ID
     * @param {string} [tenantIds] Override tenant scope
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemBoundariesApiInterface
     */
    getBoundaryRaw(requestParameters: GetBoundaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get detailed information about a system boundary
     * Get boundary by ID
     */
    getBoundary(requestParameters: GetBoundaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get all assets within this system boundary
     * @summary Get assets in boundary
     * @param {string} boundaryId Boundary ID
     * @param {number} [page] Page number
     * @param {number} [pageSize] Page size
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemBoundariesApiInterface
     */
    getBoundaryAssetsRaw(requestParameters: GetBoundaryAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get all assets within this system boundary
     * Get assets in boundary
     */
    getBoundaryAssets(requestParameters: GetBoundaryAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get compliance status and score for a boundary
     * @summary Get boundary compliance status
     * @param {string} boundaryId Boundary ID
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemBoundariesApiInterface
     */
    getBoundaryComplianceRaw(requestParameters: GetBoundaryComplianceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get compliance status and score for a boundary
     * Get boundary compliance status
     */
    getBoundaryCompliance(requestParameters: GetBoundaryComplianceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get statistics about system boundaries
     * @summary Get boundary statistics
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemBoundariesApiInterface
     */
    getBoundaryStatisticsRaw(requestParameters: GetBoundaryStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get statistics about system boundaries
     * Get boundary statistics
     */
    getBoundaryStatistics(requestParameters: GetBoundaryStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get all vulnerabilities affecting assets within this boundary
     * @summary Get vulnerabilities in boundary
     * @param {string} boundaryId Boundary ID
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemBoundariesApiInterface
     */
    getBoundaryVulnerabilitiesRaw(requestParameters: GetBoundaryVulnerabilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get all vulnerabilities affecting assets within this boundary
     * Get vulnerabilities in boundary
     */
    getBoundaryVulnerabilities(requestParameters: GetBoundaryVulnerabilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get compliance metrics for each asset in a boundary
     * @summary Get compliance breakdown by asset
     * @param {string} boundaryId Boundary ID
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemBoundariesApiInterface
     */
    getComplianceByAssetRaw(requestParameters: GetComplianceByAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get compliance metrics for each asset in a boundary
     * Get compliance breakdown by asset
     */
    getComplianceByAsset(requestParameters: GetComplianceByAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get compliance metrics for each baseline in a boundary
     * @summary Get compliance breakdown by baseline
     * @param {string} boundaryId Boundary ID
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemBoundariesApiInterface
     */
    getComplianceByBaselineRaw(requestParameters: GetComplianceByBaselineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get compliance metrics for each baseline in a boundary
     * Get compliance breakdown by baseline
     */
    getComplianceByBaseline(requestParameters: GetComplianceByBaselineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get assignment history for a specific entity (asset, user, or case)
     * @summary Get entity assignment history
     * @param {string} entityType Entity type (AssetEntity, User, Case)
     * @param {string} entityId Entity ID
     * @param {number} [page] Page number (0-indexed)
     * @param {number} [pageSize] Page size
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemBoundariesApiInterface
     */
    getEntityAssignmentHistoryRaw(requestParameters: GetEntityAssignmentHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get assignment history for a specific entity (asset, user, or case)
     * Get entity assignment history
     */
    getEntityAssignmentHistory(requestParameters: GetEntityAssignmentHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Manually trigger compliance recalculation for a boundary
     * @summary Recalculate boundary compliance
     * @param {string} boundaryId Boundary ID
     * @param {boolean} [includeParents] Include parent boundaries in recalculation
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemBoundariesApiInterface
     */
    recalculateComplianceRaw(requestParameters: RecalculateComplianceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Manually trigger compliance recalculation for a boundary
     * Recalculate boundary compliance
     */
    recalculateCompliance(requestParameters: RecalculateComplianceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Update an existing system boundary
     * @summary Update boundary
     * @param {string} boundaryId Boundary ID
     * @param {SystemBoundaryEntity} systemBoundaryEntity 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemBoundariesApiInterface
     */
    updateBoundaryRaw(requestParameters: UpdateBoundaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Update an existing system boundary
     * Update boundary
     */
    updateBoundary(requestParameters: UpdateBoundaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class SystemBoundariesApi extends runtime.BaseAPI implements SystemBoundariesApiInterface {

    /**
     * Create a new system boundary
     * Create boundary
     */
    async createBoundaryRaw(requestParameters: CreateBoundaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['systemBoundaryEntity'] == null) {
            throw new runtime.RequiredError(
                'systemBoundaryEntity',
                'Required parameter "systemBoundaryEntity" was null or undefined when calling createBoundary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/system-boundaries`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SystemBoundaryEntityToJSON(requestParameters['systemBoundaryEntity']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Create a new system boundary
     * Create boundary
     */
    async createBoundary(requestParameters: CreateBoundaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.createBoundaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a system boundary
     * Delete boundary
     */
    async deleteBoundaryRaw(requestParameters: DeleteBoundaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['boundaryId'] == null) {
            throw new runtime.RequiredError(
                'boundaryId',
                'Required parameter "boundaryId" was null or undefined when calling deleteBoundary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/system-boundaries/{boundaryId}`;
        urlPath = urlPath.replace(`{${"boundaryId"}}`, encodeURIComponent(String(requestParameters['boundaryId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a system boundary
     * Delete boundary
     */
    async deleteBoundary(requestParameters: DeleteBoundaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.deleteBoundaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get paginated assignment history for a boundary
     * Get assignment history
     */
    async getAssignmentHistoryRaw(requestParameters: GetAssignmentHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['boundaryId'] == null) {
            throw new runtime.RequiredError(
                'boundaryId',
                'Required parameter "boundaryId" was null or undefined when calling getAssignmentHistory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['changeType'] != null) {
            queryParameters['changeType'] = requestParameters['changeType'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/system-boundaries/{boundaryId}/assignment-history`;
        urlPath = urlPath.replace(`{${"boundaryId"}}`, encodeURIComponent(String(requestParameters['boundaryId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get paginated assignment history for a boundary
     * Get assignment history
     */
    async getAssignmentHistory(requestParameters: GetAssignmentHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getAssignmentHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get statistics about assignment history for a boundary
     * Get assignment history statistics
     */
    async getAssignmentHistoryStatsRaw(requestParameters: GetAssignmentHistoryStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['boundaryId'] == null) {
            throw new runtime.RequiredError(
                'boundaryId',
                'Required parameter "boundaryId" was null or undefined when calling getAssignmentHistoryStats().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/system-boundaries/{boundaryId}/assignment-history/stats`;
        urlPath = urlPath.replace(`{${"boundaryId"}}`, encodeURIComponent(String(requestParameters['boundaryId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get statistics about assignment history for a boundary
     * Get assignment history statistics
     */
    async getAssignmentHistoryStats(requestParameters: GetAssignmentHistoryStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getAssignmentHistoryStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get paginated list of system boundaries for the tenant
     * List system boundaries
     */
    async getBoundariesRaw(requestParameters: GetBoundariesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['boundaryType'] != null) {
            queryParameters['boundaryType'] = requestParameters['boundaryType'];
        }

        if (requestParameters['authorizationStatus'] != null) {
            queryParameters['authorizationStatus'] = requestParameters['authorizationStatus'];
        }

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/system-boundaries`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get paginated list of system boundaries for the tenant
     * List system boundaries
     */
    async getBoundaries(requestParameters: GetBoundariesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getBoundariesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get detailed information about a system boundary
     * Get boundary by ID
     */
    async getBoundaryRaw(requestParameters: GetBoundaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['boundaryId'] == null) {
            throw new runtime.RequiredError(
                'boundaryId',
                'Required parameter "boundaryId" was null or undefined when calling getBoundary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/system-boundaries/{boundaryId}`;
        urlPath = urlPath.replace(`{${"boundaryId"}}`, encodeURIComponent(String(requestParameters['boundaryId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get detailed information about a system boundary
     * Get boundary by ID
     */
    async getBoundary(requestParameters: GetBoundaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getBoundaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all assets within this system boundary
     * Get assets in boundary
     */
    async getBoundaryAssetsRaw(requestParameters: GetBoundaryAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['boundaryId'] == null) {
            throw new runtime.RequiredError(
                'boundaryId',
                'Required parameter "boundaryId" was null or undefined when calling getBoundaryAssets().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/system-boundaries/{boundaryId}/assets`;
        urlPath = urlPath.replace(`{${"boundaryId"}}`, encodeURIComponent(String(requestParameters['boundaryId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all assets within this system boundary
     * Get assets in boundary
     */
    async getBoundaryAssets(requestParameters: GetBoundaryAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getBoundaryAssetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get compliance status and score for a boundary
     * Get boundary compliance status
     */
    async getBoundaryComplianceRaw(requestParameters: GetBoundaryComplianceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['boundaryId'] == null) {
            throw new runtime.RequiredError(
                'boundaryId',
                'Required parameter "boundaryId" was null or undefined when calling getBoundaryCompliance().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/system-boundaries/{boundaryId}/compliance`;
        urlPath = urlPath.replace(`{${"boundaryId"}}`, encodeURIComponent(String(requestParameters['boundaryId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get compliance status and score for a boundary
     * Get boundary compliance status
     */
    async getBoundaryCompliance(requestParameters: GetBoundaryComplianceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getBoundaryComplianceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get statistics about system boundaries
     * Get boundary statistics
     */
    async getBoundaryStatisticsRaw(requestParameters: GetBoundaryStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/system-boundaries/statistics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get statistics about system boundaries
     * Get boundary statistics
     */
    async getBoundaryStatistics(requestParameters: GetBoundaryStatisticsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getBoundaryStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all vulnerabilities affecting assets within this boundary
     * Get vulnerabilities in boundary
     */
    async getBoundaryVulnerabilitiesRaw(requestParameters: GetBoundaryVulnerabilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['boundaryId'] == null) {
            throw new runtime.RequiredError(
                'boundaryId',
                'Required parameter "boundaryId" was null or undefined when calling getBoundaryVulnerabilities().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/system-boundaries/{boundaryId}/vulnerabilities`;
        urlPath = urlPath.replace(`{${"boundaryId"}}`, encodeURIComponent(String(requestParameters['boundaryId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all vulnerabilities affecting assets within this boundary
     * Get vulnerabilities in boundary
     */
    async getBoundaryVulnerabilities(requestParameters: GetBoundaryVulnerabilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getBoundaryVulnerabilitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get compliance metrics for each asset in a boundary
     * Get compliance breakdown by asset
     */
    async getComplianceByAssetRaw(requestParameters: GetComplianceByAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['boundaryId'] == null) {
            throw new runtime.RequiredError(
                'boundaryId',
                'Required parameter "boundaryId" was null or undefined when calling getComplianceByAsset().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/system-boundaries/{boundaryId}/compliance/by-asset`;
        urlPath = urlPath.replace(`{${"boundaryId"}}`, encodeURIComponent(String(requestParameters['boundaryId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get compliance metrics for each asset in a boundary
     * Get compliance breakdown by asset
     */
    async getComplianceByAsset(requestParameters: GetComplianceByAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getComplianceByAssetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get compliance metrics for each baseline in a boundary
     * Get compliance breakdown by baseline
     */
    async getComplianceByBaselineRaw(requestParameters: GetComplianceByBaselineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['boundaryId'] == null) {
            throw new runtime.RequiredError(
                'boundaryId',
                'Required parameter "boundaryId" was null or undefined when calling getComplianceByBaseline().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/system-boundaries/{boundaryId}/compliance/by-baseline`;
        urlPath = urlPath.replace(`{${"boundaryId"}}`, encodeURIComponent(String(requestParameters['boundaryId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get compliance metrics for each baseline in a boundary
     * Get compliance breakdown by baseline
     */
    async getComplianceByBaseline(requestParameters: GetComplianceByBaselineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getComplianceByBaselineRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get assignment history for a specific entity (asset, user, or case)
     * Get entity assignment history
     */
    async getEntityAssignmentHistoryRaw(requestParameters: GetEntityAssignmentHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['entityType'] == null) {
            throw new runtime.RequiredError(
                'entityType',
                'Required parameter "entityType" was null or undefined when calling getEntityAssignmentHistory().'
            );
        }

        if (requestParameters['entityId'] == null) {
            throw new runtime.RequiredError(
                'entityId',
                'Required parameter "entityId" was null or undefined when calling getEntityAssignmentHistory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/system-boundaries/assignment-history/entity/{entityType}/{entityId}`;
        urlPath = urlPath.replace(`{${"entityType"}}`, encodeURIComponent(String(requestParameters['entityType'])));
        urlPath = urlPath.replace(`{${"entityId"}}`, encodeURIComponent(String(requestParameters['entityId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get assignment history for a specific entity (asset, user, or case)
     * Get entity assignment history
     */
    async getEntityAssignmentHistory(requestParameters: GetEntityAssignmentHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getEntityAssignmentHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Manually trigger compliance recalculation for a boundary
     * Recalculate boundary compliance
     */
    async recalculateComplianceRaw(requestParameters: RecalculateComplianceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['boundaryId'] == null) {
            throw new runtime.RequiredError(
                'boundaryId',
                'Required parameter "boundaryId" was null or undefined when calling recalculateCompliance().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeParents'] != null) {
            queryParameters['includeParents'] = requestParameters['includeParents'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/system-boundaries/{boundaryId}/compliance/recalculate`;
        urlPath = urlPath.replace(`{${"boundaryId"}}`, encodeURIComponent(String(requestParameters['boundaryId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Manually trigger compliance recalculation for a boundary
     * Recalculate boundary compliance
     */
    async recalculateCompliance(requestParameters: RecalculateComplianceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.recalculateComplianceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing system boundary
     * Update boundary
     */
    async updateBoundaryRaw(requestParameters: UpdateBoundaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['boundaryId'] == null) {
            throw new runtime.RequiredError(
                'boundaryId',
                'Required parameter "boundaryId" was null or undefined when calling updateBoundary().'
            );
        }

        if (requestParameters['systemBoundaryEntity'] == null) {
            throw new runtime.RequiredError(
                'systemBoundaryEntity',
                'Required parameter "systemBoundaryEntity" was null or undefined when calling updateBoundary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/system-boundaries/{boundaryId}`;
        urlPath = urlPath.replace(`{${"boundaryId"}}`, encodeURIComponent(String(requestParameters['boundaryId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SystemBoundaryEntityToJSON(requestParameters['systemBoundaryEntity']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Update an existing system boundary
     * Update boundary
     */
    async updateBoundary(requestParameters: UpdateBoundaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateBoundaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
